export const pxToRem = (value: number) => {
  const baseFontSize = 14; // 0.875rem

  return `${value / baseFontSize}rem`;
};
